import React from "react";

const CheckButton = ({ isSubmitting, isReview, setClearanswers, label, ...props }) => {
  return isReview ? (
    <button className="btn fw-bold py-1 rounded-5" type="button" onClick={(e) => {e.preventDefault(); setClearanswers(true);}} style={{borderColor: "#07A889", color: "#07A889", backgroundColor: "rgba(240, 255, 245, 1)"}}>
      <svg width="20" height="20" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_5072_9379)">
        <path d="M13.75 6.92858V7.50358C13.7492 8.85134 13.3128 10.1627 12.5058 11.2422C11.6989 12.3217 10.5646 13.1114 9.2721 13.4935C7.97964 13.8757 6.59829 13.8298 5.33404 13.3627C4.0698 12.8956 2.99041 12.0324 2.25685 10.9017C1.52329 9.7711 1.17487 8.43362 1.26355 7.08877C1.35223 5.74393 1.87325 4.46378 2.74892 3.43925C3.6246 2.41471 4.80799 1.70069 6.12262 1.40367C7.43725 1.10665 8.81267 1.24254 10.0438 1.79108M13.75 2.5L7.5 8.75625L5.625 6.88125" stroke="#07A889" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_5072_9379">
        <rect width="15" height="15" fill="white"/>
        </clipPath>
        </defs>
      </svg>
      <span>Clear answers</span>
  </button>
  ) : label && isSubmitting ? (
    <button class="btn fw-bold py-1 rounded-5" style={{borderColor: "#07A889", color: "#07A889", backgroundColor: "rgba(240, 255, 245, 1)"}} type="button" disabled>
      <span
        class="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
      Checking
    </button>
  ) : isSubmitting ? (
    <button class="btn btn-warning btn-md float-end btn-width" type="button" disabled>
      <span
        class="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
      Checking
    </button>
  ) : label ? (
    <button className="btn fw-bold py-1 rounded-5" style={{borderColor: "#07A889", color: "#07A889", backgroundColor: "rgba(240, 255, 245, 1)"}}>
      <svg width="20" height="20" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_5072_9379)">
        <path d="M13.75 6.92858V7.50358C13.7492 8.85134 13.3128 10.1627 12.5058 11.2422C11.6989 12.3217 10.5646 13.1114 9.2721 13.4935C7.97964 13.8757 6.59829 13.8298 5.33404 13.3627C4.0698 12.8956 2.99041 12.0324 2.25685 10.9017C1.52329 9.7711 1.17487 8.43362 1.26355 7.08877C1.35223 5.74393 1.87325 4.46378 2.74892 3.43925C3.6246 2.41471 4.80799 1.70069 6.12262 1.40367C7.43725 1.10665 8.81267 1.24254 10.0438 1.79108M13.75 2.5L7.5 8.75625L5.625 6.88125" stroke="#07A889" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_5072_9379">
        <rect width="15" height="15" fill="white"/>
        </clipPath>
        </defs>
      </svg>
      <span>Check answers</span>
    </button>
  ) : (
    <input
      type="submit"
      value="Check"
      class="btn border-dark"
      style={{ backgroundColor: "white", color: "#000", width: "100px" }}
      {...props}
    />
  );
};

export default CheckButton;